import {useEffect} from "react";


//This hook is used to scroll to a ref when it is set to a specific element on the page
// Create a ref object, load up this hook, and then set the reference to the element you want to scroll to
// This is useful for when you want to send the user directly to a specific input they need to review/update
// Used on the KYC page
// Also outlines the field in red
const useFocusRef = (focusRef) => {
    useEffect(() => {
        if (!focusRef.current) {
            return;
        }
        focusRef.current.scrollIntoView({
            behavior: "smooth",
            block: 'center',
        });
        focusRef.current.style.border = '1px solid red';
    }, [focusRef.current]);
}

export default useFocusRef;